import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

type Composition = {
    id: number
    title: string  
    value: string
    category: any
}

type CompositionDto = {
    title: string  
    value: string
    category: number[]
}

export const CompositionsApi = createApi({
    reducerPath: 'CompositionsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["COMPOSITION"],
    endpoints: builder => ({
        getComposition: builder.query<Composition, { id: number }>({
            query: id => ({ url: `/composition/${id}` }),
            providesTags: ["COMPOSITION"]
        }),
        getAllCompositions: builder.query<Composition[], void>({
            query: () => ({ url: '/composition' }),
            providesTags: ["COMPOSITION"]
        }),
        createComposition: builder.mutation<any, CompositionDto>({
            query: (data)=> ({url: `/composition`, method: "POST", body: data}),
            invalidatesTags: ["COMPOSITION"]
        }),
        updateComposition: builder.mutation<any, any>({
            query: data => ({ url: `/composition/${data.id}`, method: 'PATCH', body: data }),
            invalidatesTags: ["COMPOSITION"]
        }),
        deleteCompositionsByIds: builder.mutation<any, any>({
            query: (data)=> ({url: `/composition/delete-by-ids`, method: "POST", body: data}),
            invalidatesTags: ["COMPOSITION"]
        }),
    })
})

export const { useGetCompositionQuery, useGetAllCompositionsQuery, useCreateCompositionMutation, useUpdateCompositionMutation, useDeleteCompositionsByIdsMutation } = CompositionsApi
